// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__3qf7j","left":"footer_left__tRFgQ","textAccent":"footer_textAccent__u-Epo","list":"footer_list__VOQ8U"};